module.exports = __webpack_public_path__ + "img/controllerRacs.a1595f98.png";